export class DialogClass{
    constructor(
        public titolo:string,
        public contenuto:string,
        public contenutoInHtml:boolean,
        public bottoneSi:boolean,
        public bottoneNo:boolean
    ){}
}